import { render, staticRenderFns } from "./ViajesInfoInspecciones.vue?vue&type=template&id=2565091a"
import script from "./ViajesInfoInspecciones.vue?vue&type=script&lang=js"
export * from "./ViajesInfoInspecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports